import { DEFAULT_LOCALE, type Locale, localeSchema } from '@kidshub/contracts';
import { useTranslation } from 'react-i18next';

/**
 * The active locale, narrowed back to one the product supports.
 *
 * Needed as a value rather than as a language tag wherever behaviour differs
 * per language — Turkish casing, above all.
 */
export const useLocale = (): Locale => {
  const { i18n } = useTranslation();
  return localeSchema.safeParse(i18n.language).data ?? DEFAULT_LOCALE;
};
